import React from 'react';
import {learnersTableText} from './learnersTableText';
import styles from './LearnersSearch.module.css';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const LearnersSearch = React.memo(({value, onChange, placeholder}: Props) => (
  <div className={styles.wrapper}>
    <span className={`icon-search-lg ${styles.icon}`} />
    <input
      className={styles.input}
      placeholder={placeholder ?? learnersTableText.search}
      value={value}
      onChange={ev => onChange(ev.target.value)}
    />
  </div>
));

export default LearnersSearch;
